export function normalizePsgcCode(value) {
    const digits = value?.replace(/\D/g, "") ?? "";
    if (!digits)
        return null;
    // Legacy PSA boundary sources use the former 9-digit PSGC format
    // (for example Baroy 103503000). The current RBIM catalog uses the
    // 10-digit format (1003503000), which inserts the zero after the
    // two-digit region code.
    if (digits.length === 9) {
        return `${digits.slice(0, 2)}0${digits.slice(2)}`;
    }
    if (digits.length === 10)
        return digits;
    const withoutLeadingZeros = digits.replace(/^0+/, "");
    if (!withoutLeadingZeros)
        return null;
    if (withoutLeadingZeros.length === 9) {
        return `${withoutLeadingZeros.slice(0, 2)}0${withoutLeadingZeros.slice(2)}`;
    }
    return withoutLeadingZeros;
}
//# sourceMappingURL=psgc.js.map